import { useContext, useRef } from 'react';
import { Box, Input, Spinner } from '@apia/theme';
import { AutocompleteContext } from './AutocompleteContext';
import Icon from '../../Icon';
import { TAutocomplete } from './types';
import { useColor } from './ColorContext';
import useCombinedRefs from '../../../../hooks/useCombinedRefs';

const Searchbox = ({
  inputProps,
  showSpinner,
}: {
  inputProps?: TAutocomplete['inputProps'];
  showSpinner?: boolean;
}) => {
  const {
    autocompleteEvents: { onChange, onBlur, ...props },
    id,
    keyhandler: { useIsLoading, useShowValue, useFocusedOption },
    autocompleteBox: { useIsOpen },
    disabled,
    readonly,
  } = useContext(AutocompleteContext);
  const isOpen = useIsOpen();
  const inputRef = useRef<HTMLInputElement>(null);
  const showValue = useShowValue();
  const focusedOption = useFocusedOption();
  const isLoading = useIsLoading();
  const color = useColor();

  const actualRef = useCombinedRefs(
    (inputRef || (() => {})) as any,
    (inputProps?.ref || (() => {})) as any,
  );

  return (
    <Box
      className="autocomplete__inputWrapper"
      {...props}
      sx={{
        'input, .autocomplete__downArrow': { color },
      }}
    >
      <Input
        {...inputProps}
        ref={actualRef as any}
        disabled={disabled || inputProps?.disabled}
        readOnly={readonly || inputProps?.readOnly}
        className={`autocomplete__input ${inputProps?.className ?? ''}`}
        value={showValue}
        aria-autocomplete="list"
        aria-controls={isOpen ? `list__${id}` : undefined}
        aria-expanded={isOpen}
        autoComplete={inputProps?.autocomplete || 'off'}
        aria-activedescendant={
          isOpen && focusedOption
            ? `list__item__${id}__${focusedOption.value}`
            : undefined
        }
        data-autocompleteid={`input__${id}`}
        onChange={onChange}
        onClick={(ev) => {
          const input = ev.target as HTMLInputElement;
          input.setSelectionRange(0, input.value.length);
        }}
        list={`datalist__${id}`}
        onBlur={(e) => {
          if (onBlur) {
            setTimeout(() => {
              if (inputRef.current) {
                inputRef.current.scrollLeft = 0;
              }
            }, 0);
            onBlur(e);
          }
        }}
      />
      <Box className="autocomplete__icons">
        {isLoading && showSpinner !== false && (
          <Spinner className="autocomplete__loadingSpinner" />
        )}
        {<Icon className="autocomplete__downArrow" name="ArrowDown" />}
      </Box>
      <datalist id={`datalist__${id}`} />
    </Box>
  );
};

export default Searchbox;
